import { z } from 'zod';
import '@apexdesigner/schema-tools';

export const personalAccessTokenSummary = z
  .object({
    id: z.number().describe('ID - Token record id'),

    name: z.string().describe('Name - User-supplied label'),

    displayPrefix: z
      .string()
      .describe('Display Prefix - Redacted form, e.g. "adp_…f3a9"'),

    created: z.coerce
      .date()
      .nullable()
      .optional()
      .describe('Created - When the token was minted'),

    expiresAt: z.coerce
      .date()
      .nullable()
      .optional()
      .describe('Expires At - Optional expiry'),

    lastUsedAt: z.coerce
      .date()
      .nullable()
      .optional()
      .describe('Last Used At - Last successful authentication'),

    revoked: z
      .boolean()
      .describe('Revoked - Whether the token has been revoked'),
  })
  .describe(
    'Safe listing shape for a personal access token — everything except the hash. Returned by the `mine` behavior and rendered by the management UI.',
  )
  .as('PersonalAccessTokenSummary', { embedded: true });

export { personalAccessTokenSummary as personalAccessTokenSummarySchema };
